import { Modal } from "App/Component/ui"
import React from "react"

const ModalPreviewPDF = ({ setShowModal, dataPDF }) => {
  return (
    <Modal title={"Preview PDF"} show={setShowModal} width="50%">
      <iframe src={dataPDF} width="100%" height="600px" title="PDF Preview" />
    </Modal>
  )
}

export default ModalPreviewPDF
